import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const primary500 = "primary.500";

const filled = defineStyle({
	textColor: "primary.1000",
	bgColor: "white",
	caretColor: (theme) => theme.colors.primary[1000] as string,
	borderColor: primary500,
	borderWidth: "1px",
	_invalid: {
		borderColor: "secondary-accent.500",
		_focus: {
			borderColor: "secondary-accent.500",
		},
		_focusVisible: {
			boxShadow: (theme) =>
				`0 0 0 1px ${theme.colors["secondary-accent"][500]}`,
		},
	},
	_placeholder: {
		textColor: "primary.200",
	},
	_hover: {
		bgColor: "white",
	},
	_active: {
		bgColor: "white",
	},
	_focus: {
		borderColor: primary500,
		borderWidth: "1px",
		bgColor: "white",
	},
	_focusVisible: {
		boxShadow: "0 0 0 1px #799351",
		bgColor: "white",
	},
});

export const Textarea = defineStyleConfig({
	variants: { filled },
});
